module.exports = __webpack_public_path__ + "img/palasLogo.f495844f.svg";